// Generated by purs version 0.15.16
var otherwise = true;
export {
    otherwise
};
//# sourceMappingURL=index.js.map
